// src/head.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Head = React.forwardRef(
  ({ children, ...props }, forwardedRef) => /* @__PURE__ */ jsxs("head", { ...props, ref: forwardedRef, "data-id": "__react-email-head", children: [
    /* @__PURE__ */ jsx("meta", { httpEquiv: "Content-Type", content: "text/html; charset=UTF-8" }),
    children
  ] })
);
Head.displayName = "Head";
export {
  Head
};
